import { call, put, takeEvery } from "redux-saga/effects";
import { keHoachMonApi } from "../../../api/ke-hoach/keHoachMonApi";
import { IKeHoachMonAddRequest } from "../../../model/request/ke-hoach/IKeHoachMonAddRequest";
import { IKeHoachMonSelectRequest } from "../../../model/request/ke-hoach/IKeHoachMonSelectRequest";
import { IKeHoachMonSelectSummaryGiaiDoanRequest } from "../../../model/request/ke-hoach/IKeHoachMonSelectSummaryGiaiDoanRequest";
import { IBaseRespone } from "../../../model/respone/IBaseRespone";
import { IKeHoachMonViewModel } from "../../../model/respone/ke-hoach/IKeHoachMonViewModel";
import { eKeHoachMonFullPageActionIds, IKeHoachMonFullPageActionTypes } from "../../action-types/ke-hoach/IKeHoachMonFullPageActions";
import { rootActions } from "../../actions/rootActions";
import { IIdsRequest } from "../../../model/request/IIdsRequest";
import { IKeHoachMonCopyByChuyenNganhRequest } from "../../../model/request/ke-hoach/IKeHoachMonCopyByChuyenNganhRequest";
const mainAction = rootActions.keHoach.keHoachMonFullPage;
export function* keHoachMonFullPageSaga(): any {
    yield takeEvery(eKeHoachMonFullPageActionIds.LOAD_START, loadWorker);
    yield takeEvery(eKeHoachMonFullPageActionIds.ADDING_MONHOC_START, addMonHocWorker);
    yield takeEvery(eKeHoachMonFullPageActionIds.UPDATE_START, updateWorker);
    yield takeEvery(eKeHoachMonFullPageActionIds.LOAD_PHANBOTIET_START, loadPhanBoTietWorker);
    yield takeEvery(eKeHoachMonFullPageActionIds.DELETE_START, deleteWorker);
    yield takeEvery(eKeHoachMonFullPageActionIds.PASTE_CLIPBOARD_DATA_START, pasteClipboardDataWorker);
    yield takeEvery(eKeHoachMonFullPageActionIds.TACH_KHOI_GIANG_START, tachKhoiGiangWorker);
}

function* loadWorker(action: IKeHoachMonFullPageActionTypes): any {
    const res: IBaseRespone = yield call(keHoachMonApi.Select, action.payload as IKeHoachMonSelectRequest);
    if (res.is_success) {
        yield put(mainAction.LOAD_SUCCESS(res.data));
    } else {
        yield put(
            mainAction.LOAD_ERRR(res.message ?? "Có lỗi")
        );
    }
}

function* addMonHocWorker(action: IKeHoachMonFullPageActionTypes): any {
    const res: IBaseRespone = yield call(keHoachMonApi.AddMonHoc, action.payload as IKeHoachMonAddRequest);
    if (res.is_success) {
        yield put(mainAction.ADDING_MONHOC_SUCCESS(res.data));
    } else {
        yield put(
            mainAction.ADDING_MONHOC_ERRR(res.message ?? "Có lỗi")
        );
    }
}

function* updateWorker(action: IKeHoachMonFullPageActionTypes): any {
    const res: IBaseRespone = yield call(keHoachMonApi.UpdateMonHoc, action.payload as IKeHoachMonViewModel[]);
    if (res.is_success) {
        yield put(mainAction.UPDATE_SUCCESS(res.data));
    } else {
        yield put(
            mainAction.UPDATE_ERROR(res.message ?? "Có lỗi")
        );
    }
}
function* loadPhanBoTietWorker(action: IKeHoachMonFullPageActionTypes): any {
    const res: IBaseRespone = yield call(keHoachMonApi.SelectSummaryGiaiGoan, action.payload as IKeHoachMonSelectSummaryGiaiDoanRequest);
    if (res.is_success) {
        yield put(mainAction.LOAD_PHANBOTIET_SUCCESS(res.data));
    } else {
        yield put(
            mainAction.LOAD_PHANBOTIET_ERRR(res.message ?? "Có lỗi")
        );
    }
}

function* deleteWorker(action: IKeHoachMonFullPageActionTypes): any {
    const ids = action.payload as IIdsRequest
    const res: IBaseRespone = yield call(keHoachMonApi.Deletes, ids);
    if (res.is_success) {
        yield put(mainAction.DELETE_SUCCESS(ids));
    } else {
        yield put(
            mainAction.DELETE_ERROR(res.message ?? "Có lỗi")
        );
    }
}
function* pasteClipboardDataWorker(action: IKeHoachMonFullPageActionTypes): any {
    const res: IBaseRespone = yield call(keHoachMonApi.CopyKeHoachByChuyenNganh, action.payload as IKeHoachMonCopyByChuyenNganhRequest);
    if (res.is_success) {
        yield put(mainAction.PASTE_CLIPBOARD_DATA_SUCCESS(undefined));
    } else {
        yield put(
            mainAction.PASTE_CLIPBOARD_DATA_ERROR(res.message ?? "Có lỗi")
        );
    }
}

function* tachKhoiGiangWorker(action: IKeHoachMonFullPageActionTypes): any {
    const res: IBaseRespone = yield call(keHoachMonApi.TachKhoiGiang, action.payload as number);
    if (res.is_success) {
        yield put(mainAction.TACH_KHOI_GIANG_SUCCESS(res.data));
    } else {
        yield put(
            mainAction.TACH_KHOI_GIANG_ERROR(res.message ?? "Có lỗi")
        );
    }
}